module.exports = __webpack_public_path__ + "img/zhenti.1d9f1629.png";